<template>
  <div
    v-if="filteredExistence.length > 0"
    class="main-pcLogisticExistenceUL"
  >
    <f7-list
      v-for="(contenedora, i) in filteredExistence"
      :key="i"
      class="content-logistic-list"
      accordion-opposite
      accordion-list
    >
      <f7-list-item
        class="content-logistic-list-item"
        :accordion-item-opened="i === (filteredExistence.length - 1)"
        accordion-item
        :title="contenedora.NombreAgrupacion"
      >
        <template #after>
          <img
            src="@/static/icons/ic_deleteGris.svg"
            width="30px"
            @click="DeleteExistence(contenedora)"
          >
        </template>
        <f7-accordion-content
          v-for="(partidas, j) in contenedora.Partidas"
          :key="j"
          class="content-logistic-list-item__accordion-content"
        >
          <div class="content-logistic-list-item__accordion-content--component">
            <UCAcordeon
              :items="[partidas.Partida]"
              title-option="NombreLista"
              class="mainAcordeon-merchandise-movements mainAcordeon"
              :show-checkbox="false"
              :show-badge="false"
              :closed="true"
              :opened-index="0"
              font-color="var(--his-dark-blue)"
              primary="var(--his-silver)"
              :after-title="false"
              :search-with-checkbox="false"
            >
              <template #subOptionSubtitle="{ item }">
                <f7-list
                  v-if="partidas.Partida.items.length > 1"
                  media-list
                >
                  <f7-list-item
                    checkbox
                    class="content-logistic-acordeon-list"
                    :checked="item.checked"
                    @click="SelectItem(item)"
                  >
                    <template #root-start>
                      <span
                        class="content-logistic-acordeon-list__span background-blue"
                        :class="{
                          'background-blue': item.Articulo.TipoArticulo === '2',
                          'background-green': item.Articulo.TipoArticulo === '1',
                          'background-red': item.Articulo.TipoArticulo === '0',
                        }"
                      >
                        {{ `${$t('common.stocks').toUpperCase()}: ${item.CantidadFinal} ${$t('common.of')} ${item.CantidadTotal}` }}
                      </span>
                    </template>

                    <template #title>
                      <div class="span-title">
                        {{ item.Articulo.Nombre }}
                      </div>
                    </template>

                    <div class="item-subtitle">
                      {{ item.Articulo.Codigo }}
                    </div>

                    <template #after>
                      <div>
                        <img
                          class="btnNext"
                          src="@/static/icons/ic_arrow_blue.svg"
                          width="27"
                          style="filter: none; margin-left: 10px;"
                          @click="OpenActionBatch(item)"
                        >
                      </div>
                    </template>
                  </f7-list-item>
                </f7-list>
                <f7-list
                  v-else
                  media-list
                >
                  <f7-list-item
                    checkbox
                    link="#"
                    class="content-logistic-acordeon-list"
                    :checked="item.checked"
                    @click="SelectItem(item)"
                  >
                    <template #root-start>
                      <span class="content-logistic-acordeon-list__span background-blue">
                        {{ `${$t('common.stocks').toUpperCase()}:` }}
                        {{ `${item.CantidadFinal} ${$t('common.of')} ${item.CantidadTotal}` }}
                      </span>
                    </template>

                    <template #title>
                      <div class="span-title">
                        {{ item.Articulo.Nombre }}
                      </div>
                    </template>

                    <div class="item-subtitle">
                      {{ item.Articulo.Codigo }}
                    </div>

                    <template #after>
                      <div>
                        <img
                          class="btnOptions"
                          src="@/static/icons/ic_options_blue_background.svg"
                          width="27"
                          style="filter: none;"
                          @click="SelectMerchadise(item)"
                        >
                        <img
                          class="btnNext"
                          src="@/static/icons/ic_arrow_blue.svg"
                          width="27"
                          style="filter: none; padding-left: 10px;"
                          @click="OpenActionBatch(item)"
                        >
                      </div>
                    </template>
                  </f7-list-item>
                </f7-list>
              </template>
            </UCAcordeon>
          </div>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>

    <PCLogisticExistenceLocation
      ref="PCLogisticExistenceLocationPopup"
      :existencias="accumulatedForLocation"
      @change-value="ChangeQuantityItem"
      @popup:closed="showLocationComponent = false"
    />

    <f7-actions
      class="logistic-existence-actions-sheet"
      :opened="actionChangesOpened"
      @actions:closed="actionChangesOpened = false"
    >
      <f7-block>
        <div
          v-if="accumulatedStockSelected.length > 0"
          class="content-action-sheet-logistic-existence--items text-align-center"
        >
          <span class="content-action-sheet-logistic-existence--items__title">
            {{ $t('production.common.enterQuantity') }}
          </span>
          <f7-stepper
            :key="accumulatedStockSelected[0].Id"
            fill
            class="content-action-sheet-logistic-existence--items__stepper"
            :min="0"
            :max="accumulatedStockSelected.reduce((total, item) => total + item.CantidadTotal, 0)"
            :manual-input-mode="true"
            :value="accumulatedStockSelected.reduce((total, item) => total + item.CantidadFinal, 0)"
            @input="valorInputCantidad = $event.target.value"
          />
        </div>
        <div class="content-action-sheet-logistic-existence--items__buttons">
          <a
            class=""
            @click="actionChangesOpened = false"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </a>
          <a
            class="color-green aceptar-button"
            @click="ChangeValueStepper(); actionChangesOpened = false"
          >
            {{ $t('common.accept').toUpperCase() }}
          </a>
        </div>
      </f7-block>
    </f7-actions>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState, mapWritableState } from 'pinia';
import { Log } from '@/js/common/HIDebuggingSupport';
import { ConfirmDialogGH, PreloaderGH } from '@/js/common/HINotificationSupport';
import { useWarehouseStore } from '@/js/stores/warehouse';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import PCLogisticExistenceLocation from './PCLogisticExistenceLocation.vue';

export default defineComponent({
  name: 'PCLogisticExistenceUL',
  components: {
    UCAcordeon,
    PCLogisticExistenceLocation,
  },
  data() {
    return {
      actionChangesOpened: false,
      valorInputCantidad: 0,
      dataExistence: {},
      showLocationComponent: false,
      selectedItem: null,
      selectedItemForLocation: null,
    };
  },
  computed: {
    accumulatedStockSelected() {
      return this.selectedItem ?? [];
    },

    accumulatedForLocation() {
      return this.selectedItemForLocation ?? [];
    },
    filteredExistence() {
      return this.dataExistence.length > 0 ? this.dataExistence : [];
    },
    ...mapState(useWarehouseStore, [
      'listaExistenciasMovMerc',
    ]),
    ...mapWritableState(useWarehouseStore, ['listaExistenciasMovMerc']),
  },
  watch: {
    listaExistenciasMovMerc(val) {
      if (val && val.length > 0) {
        this.FilterData();
      }
    },

  },
  methods: {
    DeleteExistence(existencia) {
      Log(this, this.DeleteExistence.name);
      this.dataExistence = this.dataExistence.filter((f) => f.UnidadContenedoraId !== existencia.UnidadContenedoraId);

      this.listaExistenciasMovMerc = this.listaExistenciasMovMerc.filter((f) => f.UnidadContenedora.Id !== existencia.UnidadContenedoraId);
    },
    ChangeQuantityItem() {
      Log(this, this.ChangeQuantityItem.name);
      this.FilterData();
    },
    SelectMerchadise(item) {
      Log(this, this.SelectMerchadise.name);
      this.selectedItemForLocation = this.listaExistenciasMovMerc.filter((f) => f.UnidadContenedora.Id === item.UnidadContenedora.Id && f.Partida.Id === item.Partida.Id);
      this.showLocationComponent = true;

      this.$refs.PCLogisticExistenceLocationPopup.OpenPopup();
    },
    OpenActionBatch(value) {
      Log(this, this.OpenActionBatch.name);
      this.selectedItem = this.listaExistenciasMovMerc.filter((f) => f.Articulo.Id === value.Articulo.Id && f.Partida.Id === value.Partida.Id && f.Almacen.Id === value.Almacen.Id);

      this.actionChangesOpened = true;
    },

    SelectItem(value) {
      Log(this, this.SelectItem.name);

      if (!this.showLocationComponent && !this.actionChangesOpened) {
        this.selectedItem = this.listaExistenciasMovMerc.filter((f) => f.Articulo.Id === value.Articulo.Id && f.Partida.Id === value.Partida.Id && f.Almacen.Id === value.Almacen.Id);

        value.checked = !value.checked;
        this.UpdateCantidadFinal(value);
        if (value.checked) {
          value.CantidadFinal += value.CantidadTotal;
        }
        this.valorInputCantidad = value.CantidadFinal;
        this.AjustarAcumulados();
      }
    },

    async AjustarAcumulados() {
      Log(this, this.AjustarAcumulados.name);
      const item = this.accumulatedStockSelected[0];

      let numeroserie = '';

      const sameUC = this.listaExistenciasMovMerc.filter((f) => f.UnidadContenedora.Id === item.UnidadContenedora.Id);

      if (item.Articulo?.TipoArticulo === '0') {
        const envase = sameUC.find((f) => f.Id !== item.Id && f.Articulo.TipoArticulo === '1');
        // Si la cantidad de envases no es la total y se añade la totalidad de pales, su muestra un mensaje avisando
        // de que está moviendo el pale sin toda la mercancia.
        if (envase && envase.Cantidad > envase.Seleccion) {
          numeroserie = item.NumeroSerie !== '' ? item.NumeroSerie : item.UnidadContenedora.NumeroSerie;
          await this.MostrarAlerta(numeroserie);
        }

        envase.checked = envase.Seleccion > 0;
      } else {
        // si es envase o producto

        item.Seleccion = Number.parseInt(this.valorInputCantidad, 10);
        item.checked = item.Seleccion > 0;
        const otroItem = sameUC.find((f) => f.Id !== item.Id && f.Articulo.TipoArticulo !== '0');

        if (otroItem) {
          if (otroItem.Articulo.TipoArticulo === '2') {
            otroItem.Seleccion = parseFloat(
              ((item.Seleccion * otroItem.Cantidad) / item.Cantidad).toFixed(2),
            );
          } else {
            otroItem.Seleccion = Math.ceil(
              (item.Seleccion * otroItem.Cantidad) / item.Cantidad,
            );
          }
        }
        const pale = sameUC.find((f) => f.Articulo.TipoArticulo === '0');
        const envase = sameUC.find((f) => f.Articulo.TipoArticulo === '1');

        let cantidadFinal = 1;

        if (envase && envase.Cantidad > envase.Seleccion) {
          cantidadFinal = (pale && pale.Cantidad === 1) ? 0 : envase.Cantidad % envase.Seleccion;
        }

        if (pale) {
          pale.Seleccion = cantidadFinal;
        }
        pale.checked = pale.Seleccion > 0;
        envase.checked = envase.Seleccion > 0;
      }
    },

    async ChangeValueStepper() {
      Log(this, this.ChangeValueStepper.name);
      this.AjustarAcumulados();

      this.FilterData();
      // let mostrarMensajeAlerta = false;
      // let numeroserie = '';
      // /* Cuando modifico producto me autocalcula el numero de envases y viceversa y
      // ademas si el numero de envases no es el total de la partida en cantidad de pales me pone 0 o la proporcion que corresponda (MOD).
      // Cuando se modifica el palé no hace nada con el envase ni el producto. */
      // this.dataExistence.forEach((d) => {
      //   Object.keys(d.Partidas).forEach((clavePartida) => {
      //     const itemsDePartida = d.Partidas[clavePartida].Partida.items;

      //     console.log('itemsDePartida', itemsDePartida);
      //     if (itemsDePartida.length > 1) {
      //       const itemActual = itemsDePartida.find((f) => f.Id === this.accumulatedStockSelected[0].Id);

      //       console.log('itemActual', itemActual);
      //       if (!itemActual) return; // No encontró el item

      //       // comprobamos que accumulatedStockSelected sea un pale
      //       if (itemActual.Articulo?.TipoArticulo === '0') {
      //         const envase = itemsDePartida.find((f) => f.Id !== this.accumulatedStockSelected[0].Id && f.Articulo.TipoArticulo === '1');
      //         // Si la cantidad de envases no es la total y se añade la totalidad de pales, su muestra un mensaje avisando
      //         // de que está moviendo el pale sin toda la mercancia.
      //         if (envase && envase.Cantidad > envase.Seleccion) {
      //           mostrarMensajeAlerta = true;
      //           numeroserie = itemActual.NumeroSerie;
      //         } else {
      //           itemActual.Seleccion = Number.parseInt(this.valorInputCantidad, 10);
      //         }

      //         envase.checked = envase.Seleccion > 0;
      //       } else {
      //         // si es envase o producto
      //         itemActual.Seleccion = Number.parseInt(this.valorInputCantidad, 10);

      //         const otroItem = itemsDePartida.find((f) => f.Id !== this.accumulatedStockSelected[0].Id && f.Articulo.TipoArticulo !== '0');

      //         if (otroItem) {
      //           if (otroItem.Articulo.TipoArticulo === '2') {
      //             otroItem.Seleccion = parseFloat(
      //               ((this.accumulatedStockSelected[0].Seleccion * otroItem.Cantidad) / this.accumulatedStockSelected[0].Cantidad).toFixed(2),
      //             );
      //           } else {
      //             otroItem.Seleccion = Math.ceil(
      //               (this.accumulatedStockSelected[0].Seleccion * otroItem.Cantidad) / this.accumulatedStockSelected[0].Cantidad,
      //             );
      //           }
      //         }
      //         const pale = itemsDePartida.find((f) => f.Id !== this.accumulatedStockSelected[0].Id && f.Articulo.TipoArticulo === '0');
      //         const envase = itemsDePartida.find((f) => f.Articulo.TipoArticulo === '1');

      //         let cantidadFinal = 1;

      //         if (envase && envase.Cantidad > envase.Seleccion) {
      //           cantidadFinal = (pale && pale.Cantidad === 1) ? 0 : envase.Cantidad % envase.Seleccion;
      //         }

      //         if (pale) {
      //           pale.Seleccion = cantidadFinal;
      //         }
      //         pale.checked = pale.Seleccion > 0;
      //         envase.checked = envase.Seleccion > 0;
      //       }

      //       itemActual.checked = itemActual.Seleccion > 0;
      //     }
      //   });
      // });

      // if (mostrarMensajeAlerta) {
      //   await this.MostrarAlerta(numeroserie);
      // }

      // this.FilterData();
    },

    async MostrarAlerta(numeroserie) {
      const alertTitle = this.$t('production.movingPallet.title', { pallet: numeroserie });
      const alertText = this.$t('production.movingPallet.text', { pallet: numeroserie });

      const resultConfirm = await ConfirmDialogGH(alertText, alertTitle);
      if (resultConfirm) {
        this.accumulatedStockSelected[0].Seleccion = Number.parseInt(this.valorInputCantidad, 10);
        this.accumulatedStockSelected[0].checked = this.accumulatedStockSelected[0].Seleccion > 0;
      }
    },

    UpdateCantidadFinal(item) {
      Log(this, this.UpdateCantidadFinal.name);
      // if (Object.hasOwn(item, 'CantidadFinal') && Object.hasOwn(item, 'CantidadTotal')) return;

      if (!Object.hasOwn(item, 'CantidadFinal')) {
        item.CantidadFinal = 0;
      }
      if (!Object.hasOwn(item, 'CantidadTotal')) {
        item.CantidadTotal = item.Cantidad;
      }

      if (!Object.hasOwn(item, 'Seleccion')) {
        item.Seleccion = item.CantidadFinal;
      }

      if (!item.checked) {
        item.Seleccion = 0;
        item.CantidadFinal = 0;
      }

      if (Number.isInteger(item.CantidadFinal)) {
        Number(item.CantidadFinal);
      } else {
        item.CantidadFinal = Number.parseFloat(item.CantidadFinal.toFixed(2));
      }
    },

    FilterData() {
      Log(this, this.FilterData.name);
      PreloaderGH(true, true, this.$t('common.loadingData'), '');
      const resultado = [];
      const idsUnidadContenedora = [];
      const idsPartida = {};
      const idsSinUc = [];

      this.listaExistenciasMovMerc.forEach((existencia) => {
        this.UpdateCantidadFinal(existencia);
        let idUnidadContenedora = 0;
        let numeroSerie = '';

        const e = { ...existencia };

        idUnidadContenedora = e.UnidadContenedora ? e.UnidadContenedora.Id : e.Id;
        numeroSerie = e.UnidadContenedora
          ? `${this.$t('common.logisticsUnit')}: ${e.UnidadContenedora.NumeroSerie}`
          : `${this.$t('common.serialNumberShort')}: ${e.NumeroSerie}`;
        const { Id: idPartida } = e.Partida;
        const partida = `${this.$t('common.batch')}: ${e.Partida.Serie}/${e.Partida.Numero}`;

        const partidas = {};
        const item = e;

        const contenedoraIndex = idsUnidadContenedora.indexOf(idUnidadContenedora);
        if (contenedoraIndex === -1) {
          item.CantidadFinal = item.Seleccion;
          idsUnidadContenedora.push(idUnidadContenedora);

          if (Object.hasOwn(idsPartida, `${partida}, ${numeroSerie}`)) {
            idsPartida[`${partida}, ${numeroSerie}`].push([idPartida]);
          } else {
            idsPartida[`${partida}, ${numeroSerie}`] = [idPartida];
          }

          partidas[partida] = {
            Partida: { NombreLista: partida, items: [item] },
          };

          resultado.push({
            UnidadContenedoraId: idUnidadContenedora,
            NombreAgrupacion: numeroSerie,
            Partidas: partidas,
          });
        } else if (!Object.hasOwn(idsPartida, `${partida}, ${numeroSerie}`)) {
          idsPartida[`${partida}, ${numeroSerie}`] = [idPartida];
          item.CantidadFinal = item.Seleccion;
          resultado[contenedoraIndex].Partidas[partida] = {
            Partida: { NombreLista: partida, items: [item] },
          };
        } else {
          item.CantidadFinal = item.Seleccion;
          resultado[contenedoraIndex].Partidas[partida].Partida.items.push(item);
        }
      });

      if (idsSinUc.length > 0) {
        idsSinUc.forEach((e) => {
          const objPartida = this.listaExistenciasMovMerc.find((f) => f.Partida.Id === e.Partida.Id);
          let idUC = 0;
          if (objPartida) {
            idUC = objPartida.UnidadContenedora.Id;
          }

          if (idUC > 0) {
            resultado.forEach((d) => {
              if (d.UnidadContenedoraId === idUC) {
                for (const clavePartida in d.Partidas) {
                  if (Object.hasOwn(d.Partidas, clavePartida)) {
                    d.Partidas[clavePartida].Partida.items.push(e);
                  }
                }
              }
            });
          }
        });
      }

      this.dataExistence = resultado;
      PreloaderGH(false);
    },

  },
});
</script>

<style lang="scss">
.main-pcLogisticExistenceUL {
  background: white;

  .accordion-item > .item-link {
    background-color: var(--his-slate-blue);
    --f7-list-chevron-icon-color: #fff;
    --f7-list-item-title-font-weight: 600;

    .item-content .item-inner .item-title {
      color: white;
      font-weight: 500;
    }
  }

  .storybook-action-sorted-accordion .accordion-list .sorted-accordion {
    .accordion-item-content .search-list .item-content {
      padding-left: 0;

      .item-checkbox > .icon-checkbox {
        margin-right: 8px;
      }
    }
  }

  .mainAcordeon-merchandise-movements {
    .accordion-list .accordion-item .item-inner .item-link .item-title {
      font-weight: 500;
    }

    .storybook-action-sorted-accordion .accordion-list .sorted-accordion .item-after img:nth-child(2) {
      --webkit-filter: none;
    }

    .content-logistic-acordeon-list {
      .item-link {
        .item-content {
          .item-inner {
            padding-right: 10px;

            .item-title-row {
              padding-right: 2px;

              .item-after {
                .btnNext {
                  margin-left: 10px;
                  --webkit-filter: none;
                }
              }
            }
          }
        }
      }
    }

    .content-logistic-acordeon-list__span {
      margin-top: 10px;
      width: 100%;
      display: flex;
      justify-content: center;
      border-radius: 5px;
      padding: 2px 0;
    }

    .span-title {
      font-size: 17px;
      padding-top: 10px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }

    .background-blue {
      background: var(--his-blueberry-mist);
      color: var(--his-slate-blue);
    }

    .background-green {
      background: var(--his-melon-tint);
      color: var(--his-greenlight);
    }

    .background-red {
      background: var(--his-tomate-tint);
      color: var(--his-tomate);
    }
  }
}

.logistic-existence-actions-sheet {
  background-color: #fff;

  .content-action-sheet-logistic-existence {
    &--items {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 60px;

      &__title {
        font-size: 18px;
        font-weight: 400;
        padding-bottom: 24px;
        color: var(--his-steel-blue);
      }

      &__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: white;

        a {
          font-size: 14px;
          font-weight: 400;
        }

        .aceptar-button {
          font-size: 18px;
          font-weight: 500;
        }
      }

      &__stepper {
        --f7-stepper-fill-button-text-color: #fff;
        --f7-stepper-height: 36px;
        --f7-stepper-border-radius: 0px;

        .stepper-input-wrap {
          input {
            width: 100px;
            border: none;
          }
        }

        .actions-label::after {
          height: 0 !important;
        }
      }
    }
  }
}
</style>
